import FillingSpinner from 'components/FillingSpinner'
import React, { ReactNode, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DatePickerSingle from 'components/Form/DatePickerSingle'
import { DATE_PLACEHOLDER } from 'constant'
import { FormData, formDataDefault, FormDataErrors, formDataErrorsDefault } from './types'
import Input from 'components/Form/Input'
import Button from 'components/Form/Button'
import '../../Report.scss'
import { useSelector } from 'react-redux'
import { RootState, store } from '../../../../store'
import CommonReport from '../../components/CommonReport'
import { reportActions } from '../../store/report-slice'
import CommonReportsService from '../../services/common-reports.service'
import { FETCH_REPORT_DELAY } from '../../utils/report.constants'

const MediumCampaignsReport: React.FC = () => {
  const reportType = 'mediumCampaigns'
  const { t } = useTranslation()
  const [formData, setFormData] = useState<FormData>(formDataDefault)
  const [errors, setErrors] = useState<FormDataErrors>({ ...formDataErrorsDefault })
  const { mediumCampaigns } = useSelector((state: RootState) => state.report)

  // We need it to fetch reports on page load
  useEffect(() => {
    void CommonReportsService.fetchReports(reportType)
  }, [])

  const generateReport = async () => {
    const inputErrors = CommonReportsService.validateMainInput(formData.asId, true)

    setErrors({
      ...errors,
      asId: [...inputErrors],
    })

    if (inputErrors.length) {
      return
    }

    Promise.resolve(store.dispatch(reportActions.setLoading({ key: reportType, loading: true })))
      .then(() =>
        CommonReportsService.createMediumCampaignsReport({
          asId: formData.asId,
          startDate: formData.startDate,
          endDate: formData.endDate,
        })
      )
      .then(() => new Promise(resolve => setTimeout(resolve, FETCH_REPORT_DELAY)))
      .then(() => CommonReportsService.fetchReports(reportType))
      .finally(
        () => void store.dispatch(reportActions.setLoading({ key: reportType, loading: false }))
      )
  }

  const Form = (): ReactNode => (
    <div className='Report__form'>
      <Input
        id='asId'
        title={t('report.mediumId')}
        placeholder='89716'
        value={formData.asId.toString()}
        onChange={(value: string) => void setFormData({ ...formData, asId: value })}
        errors={errors?.asId}
        disabled={mediumCampaigns.loading}
      />

      <DatePickerSingle
        id='startDate'
        value={formData.startDate ?? ''}
        title={t('common.from')}
        placeholder={DATE_PLACEHOLDER}
        onChange={(value: string) => {
          setFormData({ ...formData, startDate: !value ? null : value })
        }}
        isOutsideRange={() => false}
        disabled={mediumCampaigns.loading}
      />

      <DatePickerSingle
        id='endDate'
        value={formData.endDate ?? ''}
        title={t('common.to')}
        placeholder={DATE_PLACEHOLDER}
        onChange={(value: string) => {
          setFormData({ ...formData, endDate: !value ? null : value })
        }}
        isOutsideRange={() => false}
        disabled={mediumCampaigns.loading}
      />

      <div className='Report__generate-button-container'>
        <Button
          onClick={generateReport}
          disabled={mediumCampaigns.loading}
        >
          {t('report.generate')}
        </Button>
      </div>
    </div>
  )

  return (
    <>
      {Form()}
      {mediumCampaigns.loading ? (
        <FillingSpinner className='Report__loading' />
      ) : (
        CommonReport.ReportTable(mediumCampaigns.reports, t)
      )}
    </>
  )
}

export default MediumCampaignsReport
